var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRubleSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 320C319.406 320 384 255.406 384 176S319.406 32 240 32H104C81.906 32 64 49.906 64 72V240H40C17.906 240 0 257.906 0 280S17.906 320 40 320H64V352H32C14.328 352 0 366.328 0 384S14.328 416 32 416H64V440C64 462.094 81.906 480 104 480S144 462.094 144 440V416H288C305.672 416 320 401.672 320 384S305.672 352 288 352H144V320H240ZM144 112H240C275.297 112 304 140.703 304 176S275.297 240 240 240H144V112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubleSign);
export default __webpack_public_path__ + "static/media/ruble-sign.39b0f90d1422d116ed67a304f4645254.svg";
export { ForwardRef as ReactComponent };